import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import style from './Aside.module.scss'

const Aside = () => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()
  return (
    <>
      {!viewport.mobile ? (
        <aside className={style.aside}>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'department')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'price')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'brand')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'fullfillment')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'subscription')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'availability')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'specialOffers')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'customerRating')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'features')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'recommendedLocation')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'category')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'retailer')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'gifting')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
          <EmptyLink color="#0053e2">
            <div className={style.asideItem}>
              <span className={style.text}>{t('questions', 'ec', 'walmart', 'type')}</span>
              <i className="wm-ChevronDown" />
            </div>
          </EmptyLink>
        </aside>
      ) : null}
    </>
  )
}

export default Aside
